import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import URLogo from "images/ur-logo-white.inline.svg";

const VIPartnerShip = () => {
  return (
    <div className="relative flex items-center justify-center -z-10 bg-black-lighter planet:bg-gray-dark">
      <div className="absolute h-full">
        <StaticImage
          src={"../../images/splash-ill.inline.svg"}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div
        className="relative md:gvi-container py-14 md:py-28 text-center
      before:absolute before:md:w-1/2 before:md:h-full before:left-0 before:top-0 before:md:bg-gradient-to-r before:from-black-lighter before:planet:from-gray-dark before:to-transparent
      before:w-full before:h-1/2 before:bg-gradient-to-b
      after:absolute after:md:w-1/2 after:md:h-full after:right-0 after:md:top-0 after:md:bg-gradient-to-r after:from-transparent after:to-black-lighter after:planet:to-gray-dark
      after:bottom-0 after:w-full after:h-1/2 after:bg-gradient-to-b"
      >
        <div className="relative z-10">
          <div
            className="w-3/5 md:w-auto text-xl font-light text-white font-body mb-8 mx-auto md:mb-2"
            dangerouslySetInnerHTML={{
              __html: "Includes courses in partnership with"
            }}
          />
          <div
            className="w-3/4 md:w-auto text-[26px] md:text-[2rem] !font-semibold !text-white mb-14 mx-auto"
            dangerouslySetInnerHTML={{
              __html: "Richmond School of Professional & Continuing Studies"
            }}
          />
          <URLogo className="w-5/6 md:w-1/4 mx-auto" />
        </div>
      </div>
    </div>
  );
};

export { VIPartnerShip };
